import React, { useContext } from 'react';

export class UninstalledDependency extends Error {
}

export function createDependency<T>(defval?: T): [() => T, (value: T) => <Arg extends React.ReactNode>(arg: Arg) => JSX.Element] {
    const Context = React.createContext<T | undefined>(defval);

    const useDependency = () => {
        const dependency = useContext(Context);
        if (!dependency) {
            throw new UninstalledDependency();
        }
        return dependency;
    };

    const withDependency = (value: T) => {
        function _<Arg extends React.ReactNode>(arg: Arg) {
            return <Context.Provider value={value}>{arg}</Context.Provider>;
        }
        return _;
    };

    return [useDependency, withDependency];
}
